import { render, staticRenderFns } from "./HistoricoPepMicro.vue?vue&type=template&id=b1167a1c&scoped=true&"
import script from "./HistoricoPepMicro.vue?vue&type=script&lang=js&"
export * from "./HistoricoPepMicro.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoPepMicro.vue?vue&type=style&index=0&id=b1167a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1167a1c",
  null
  
)

export default component.exports